<template>
  <nav class="navbar navbar-inverse navbar-fixed-top z-depth-1 b-0 new-header">
    <div class="container">

      <div class="navbar-header">
        <router-link to="/" class="navbar-brand hidden-xs"><img src="~assets/logo.png"></router-link>
        <router-link to="/" class="navbar-brand visible-xs"><img src="~assets/logo-xs.png"></router-link>
      </div>

      <ul class="nav navbar-nav">
        <li :class="{ active: context === 'patient' }"><router-link to="/patient">Patient</router-link></li>
        <li :class="{ active: context === 'practice' }"><router-link to="/practice">Practice</router-link></li>
        <li :class="{ active: context === 'academic' }"><router-link to="/academic">Academic</router-link></li>
      </ul>

      <div class="navbar-right nav-xs">
        <router-link to="/login" class="btn btn-primary navbar-btn">Login</router-link>
        <router-link to="/signup" class="btn btn-primary navbar-btn m-l">Signup</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'nav-bar',
    computed: mapState([
      'context',
    ]),
  };

</script>



// WEBPACK FOOTER //
// NavBar.vue?2a07401e